import React from "react";
import {ItemList} from "../ItemList";
import moment from "moment-timezone";
import {PatientOrderModal} from "./PatientOrderModal";
import {nlToBr} from "../../../utils/Strings";

export class PatientOrderList extends ItemList {

    idField = 'id';
    updateProperty = 'patientId';
    itemTypeName = 'Order';
    newItem = () => {
        return {
            id: 0,
            patientId: this.props.patientId,
            assignedTo: 'AUTHORIZATIONS DPT.',
            dueDate: moment().format('M/D/YYYY'),
            taskType: 'AUTH',
            createdByUserId: null,
            createdBy: null,
            taskDescription: 'Authorization',
            notes: []
        };
    };

    headerColumns = ['Created', 'Due Date', 'Type', 'Ordered By', 'Assignee', 'Status', 'Notes'];
    headerColumnClasses = ['text-center', 'text-center', '', '', '', '', ''];
    dataColumnClasses = ['text-center', 'text-center', '', '', '', '', 'w-50'];
    addSupported = false;
    editSupported = false;
    deleteSupported = false;
    paging = false;
    modalClass = PatientOrderModal;

    getBaseUrl = () => {
        return `/patients/${this.props.patientId}/orders`;
    };

    /**
     * @param r
     * @returns the contents of the table cells for a particular item.
     */
    getItemCellContents = (o) => {
        return [
            moment(o.created).format('M/D/YY'),
            moment(o.dueDate).format('M/D/YY'),
            o.taskType,
            o.orderedBy,
            o.assigneeUsername,
            <>{o.status}{o.statusReason ? <><br/> ({o.statusReason})</> : <></>}</>,
            nlToBr(o.body)
        ];
    };
}